<div class="font-size-label">
  {{label | translate}}
</div>
<div class="font-sizes">
  <div class="item" (click)="setValue(fontSize)" [class.item-active]="value == fontSize" [style.fontSize.px]="fontSize" *ngFor="let fontSize of fontSizes">
    {{fontSize}}px
  </div>
</div>
